'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserCookies = require('./UserCookies');

exports.default = function () {
  return (0, _UserCookies.getUtk)() || null;
};

module.exports = exports['default'];